/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon20Regular = forwardRef('CheckCircleCutIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.081 3.791a6.499 6.499 0 0 1 3.934.03.75.75 0 0 0 .465-1.425 7.999 7.999 0 1 0 5.473 8.462.75.75 0 0 0-1.492-.16 6.498 6.498 0 1 1-8.38-6.907Z" }),
        React.createElement("path", { d: "M18.124 5.237a.75.75 0 1 0-1.06-1.06l-6.708 6.707a.813.813 0 0 1-1.15 0L6.878 8.555a.75.75 0 1 0-1.06 1.06l2.33 2.33a2.312 2.312 0 0 0 3.27 0l6.707-6.708Z" })));
});
